import type { LeadRulesResponse, SaveLeadRulesInput } from '@viq-admin/types';

/** An inventory question the editor can require (discovery_questions of the company). */
export interface LeadRulesInventoryQuestion {
  id: string;
  text: string;
}

/**
 * Injected by each shell (closure-only — no fetch or endpoint strings in
 * packages/*). Portal: /v1/admin/company/lead-rules. Console:
 * /v1/superadmin/companies/:id/lead-rules. `save` rejects with the shell's
 * Refine HttpError; a 409 means someone else saved first.
 */
export interface LeadRulesApi {
  get(): Promise<LeadRulesResponse>;
  save(input: SaveLeadRulesInput): Promise<LeadRulesResponse>;
  listInventoryQuestions(): Promise<LeadRulesInventoryQuestion[]>;
}

/** Both shells throw Refine HttpError objects: `{ statusCode, message, errors? }`. */
export function isConflictError(err: unknown): boolean {
  return (err as { statusCode?: unknown } | null | undefined)?.statusCode === 409;
}
